module.exports = __webpack_public_path__ + "img/2_06.7243d6bc.jpg";